import {SlideshowPlugin} from './plugin'
import { Slideshow } from './slideshow'
import {injectable, inject} from 'inversify'
import {PubSub} from "@/Core/PubSub";

let createCssString = (customerColor: string, customerTutorialLineColor: string) => {
    return `
button, a.button, ul[data-answers] > li, .multiple-choice ul[data-answers]>li {
    border-color: ${customerColor};
    color: ${customerColor};
}

button:hover:enabled, a.button:hover:enabled {
    background-color: ${customerColor};
}

.customer-color-button {
    background-color: ${customerColor};
}

.customer-color-button:hover {
    background-color: #333;
}

.footer {
    border-color: ${customerTutorialLineColor};
}

input[type="checkbox"] + label::before {
    border-color: ${customerColor};
}

input[type="checkbox"]:checked + label::before {
    background-color: ${customerColor};
}

input[type="checkbox"] + label:hover::before {
    background-color: ${customerColor};
}

.customer-color, #slide-controls {
    color: ${customerColor};
}

.customer-background-color {
    background-color: ${customerColor};
}

.customer-button-background-color {
    background-color: ${customerColor};
}
`;
};

@injectable()
export class CustomerCustomisationPlugin implements SlideshowPlugin {
    logoPath: string;
    greyLogoPath: string;

    constructor(@inject("Slideshow") private slideshow: Slideshow,
        @inject("PubSub") private pubSub: PubSub) {}

    initialise(slideshow: Slideshow): Promise<any> {
        let appearance = this.slideshow.variables.customer.appearance;
        if (appearance.logoForContent == null) {
            this.logoPath = "../../../dist/img/customer-placeholder.svg";
        }
        else {
            this.logoPath = '/files/' + appearance.logoForContent;
        }

        if (appearance.logoForBranding == null) {
            this.greyLogoPath = this.logoPath;
        }
        else {
            this.greyLogoPath = '/files/' + appearance.logoForBranding;
        }

        let cssString = createCssString(
            appearance.primaryColour,
            appearance.tutorialLineColour);

        let style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = cssString;
        document.head.appendChild(style);

        return Promise.resolve();
    }
}